export default __webpack_public_path__ + "static/media/lic.09b2a8a9.svg";